import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 8px;
  width: 100%;

  @media (min-width: 900px) {
    height: 100%;
    justify-content: space-between;
  }
`;

export const HeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  margin-bottom: 32px;

  img {
    width: 56px;
    height: 56px;
  }
`;

export const InfoContainer = styled.div``;

export const ProductName = styled.h5`
  color: #555658;
  font-size: 18px;
  font-weight: 500;
  margin: 7px 0;
`;

export const Link = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  a {
    color: var(--blue-einstein);
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    text-decoration: none;
  }

  svg {
    width: 12px;
    fill: var(--blue-einstein);
  }
`;

export const Price = styled.p`
  color: #555658;
  font-size: 18px;
  font-weight: 500;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  justify-content: space-between;
  margin-top: 24px;

  @media (min-width: 900px) {
    margin-top: 40px;
  }
`;

export const BodyWrapper = styled.div``;

export const Info = styled.div`
  color: #898b8e;
  font-size: 14px;
  font-weight: 400;

  margin-top: 16px;
`;

export const GridContador = styled.div``;

export const DescriptonServiceItem = styled.div`
  color: #898b8e;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 8px;
  text-align: justify;
  text-justify: inter-character;
`;

export const CloseWrapper = styled.div`
  margin-top: 16px;
`;

export const WrapperInfo = styled.div`
  margin-top: 24px;

  @media (min-width: 900px) {
    margin-top: 40px;
  }
`;

interface ButtonWrapper {
  showPrices: boolean | undefined;
}

export const ButtonWrapper = styled.div<ButtonWrapper>`
  margin-top: ${props => (props.showPrices ? '55px' : '64px')};

  @media (min-width: 900px) {
    margin-top: 0;
    padding: 24px 0;
  }
`;
